import { useEffect, useState } from "react";

function useLanguage({ searchParams = {}, setSearchParams = () => {} }) {
  const sessionLanguage = sessionStorage.getItem("language");
  const [activeLanguage, setActiveLanguage] = useState(sessionLanguage ?? "ko");

  const handleActiveLanguage = (data) => {
    setActiveLanguage(data);
    sessionStorage.setItem("language", data);
    if (searchParams !== undefined) {
      setSearchParams(
        {
          ...searchParams,
          language: data,
        },
        { replace: true },
      );
    }
  };

  // 260319 12:52 신평호 수정
  // useEffect(() => {
  //     if(sessionLanguage !== undefined) {
  //         setActiveLanguage(sessionLanguage);
  //     } else if(searchParams !== undefined) {
  //         setActiveLanguage(searchParams.get("language") ?? 'ko');
  //     } else {
  //         setActiveLanguage('ko');
  //     }
  // }, []);

  useEffect(() => {
    if (sessionLanguage != null) {
      setActiveLanguage(sessionLanguage);
    } else if (searchParams?.get?.("language")) {
      setActiveLanguage(searchParams.get("language"));
    } else {
      setActiveLanguage("ko");
    }
  }, []);

  return [activeLanguage, handleActiveLanguage];
}

export default useLanguage;

export function useParamLanguage({
  searchParams = { language: "ko" },
  setSearchParams = () => {},
}) {
  const [activeLanguage, setActiveLanguage] = useState(
    searchParams.get("language") ?? "ko",
  );

  const handleActiveLanguage = (data) => {
    setActiveLanguage(data);
    setSearchParams(
      {
        ...searchParams,
        language: data,
      },
      { replace: true },
    );
  };

  useEffect(() => {
    setActiveLanguage(searchParams.get("language") ?? "ko");
  }, []);

  return [activeLanguage, handleActiveLanguage];
}
